import React from "react"
import {useTranslation} from "react-i18next"
import {KlassDropdown, KlassDropdownAsyncProps} from "../Select"
import {useEmailAndSmsTemplates} from "hooks/useEmailAndSmsTemplates"
import {TemplateType} from "types/settings/email-template"
import {groupBy} from "lodash"

type Props = Partial<KlassDropdownAsyncProps> & {
    templateTypes?: string[]
    enabled?: boolean
    showGroup?: boolean
}

export function MessageTemplateSelect(props: Props) {
    const {t} = useTranslation(["common"])
    const {templateTypes = [TemplateType.Email, TemplateType.SMS], showGroup = false, enabled = true} = props

    const {templates, isLoading} = useEmailAndSmsTemplates({templateTypes, enabled})
    const dataFormatted = templates.map(({title, ...rest}) => ({...rest, title: `${title} (${rest.code})`}))
    const formattedTemplates = showGroup
        ? Object.entries(groupBy(dataFormatted, "templateType")).map(([label, options]) => ({
              label,
              options
          }))
        : dataFormatted

    return (
        <KlassDropdown
            {...props}
            isLoading={isLoading}
            placeholder={props.placeholder || t("selectField.placeholder")}
            options={formattedTemplates}
            valueKey="emailTemplateId"
            getOptionLabel={(option) => option.title}
        />
    )
}
